import { LogEntry } from './log-entry.model';
import { LogPublisher } from './log-publisher';

export class LogToConsole extends LogPublisher {
    override log(record: LogEntry): void {
        console.log(record.buildLogString());
    }
    override clear(): void {
        console.clear();
    }
}
